import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import {
  RequestReferralFaxNumberFormData,
  RequestReferralPostAddressFormData,
  RequestReferralPharmacyAddressFormData,
  RequestReferralEmailAddressFormData,
  RequestReferralDeliveryMethodContentData,
  RequestReferralDoctorContentData,
  RequestReferralPatientContentData,
  RequestReferralPatientIdContentData,
  RequestReferralSpecialistFormData,
} from '@/lib/validation';

type State = {
  patient: RequestReferralPatientContentData | null;
  doctor: RequestReferralDoctorContentData | null;
  specialist: RequestReferralSpecialistFormData | null;
  deliveryMethod: RequestReferralDeliveryMethodContentData | null;
  emailAddress: RequestReferralEmailAddressFormData['emailAddress'] | null;
  faxNumber: RequestReferralFaxNumberFormData['faxNumber'] | null;
  postAddress: RequestReferralPostAddressFormData | null;
  pharmacyAddress: RequestReferralPharmacyAddressFormData | null;
  patientId: RequestReferralPatientIdContentData | null;
};

type Actions = {
  setData: (data: Partial<State>) => void;
  resetData: (data?: (keyof State)[]) => void;
};

const initialState: State = {
  patient: null,
  doctor: null,
  specialist: null,
  deliveryMethod: null,
  emailAddress: null,
  faxNumber: null,
  postAddress: null,
  pharmacyAddress: null,
  patientId: null,
};

const useRequestReferralStoreBase = createWithEqualityFn<State & Actions>()(set => ({
  ...initialState,
  setData: data =>
    set(state => ({
      ...state,
      ...data,
    })),
  resetData: data =>
    set(state => {
      if (!data) return initialState;

      data.forEach((name: keyof State) => {
        if (Object.prototype.hasOwnProperty.call(initialState, name)) {
          // Narrow the type based on the key
          (state[name] as State[typeof name]) = initialState[name];
        }
      });

      return state;
    }),
}));

export const useRequestReferralStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useRequestReferralStoreBase(selector, shallow);
};
